<template>
    <div class="towards-zero" v-bind:class="{ '-menu-opened' : isNavMenuOpenedDelay }">

        <div class="project-title">
            <a v-link="{ name: 'home' }" v-on:click="logoClicked" tabindex="0" aria-label="Back to Project Graham Homepage">
                <div class="svg-container-logo">
                    <img class="logo" src="../assets/images/logo.png" alt="Project Graham Logo">
                </div>
            </a>
        </div>

    </div>
</template>

<script>
    import { disableGlobalOverlay, closeNavMenu, closeNavMenuDelay } from '../vuex/actions'

    export default {
        vuex: {
            getters: {
                isGlobalOverlayEnabled: state => state.isGlobalOverlayEnabled,
                isNavMenuOpenedDelay: state => state.isNavMenuOpenedDelay,
                isNavMenuOpened: state => state.isNavMenuOpened
            },
            actions: {
                disableGlobalOverlay,
                closeNavMenuDelay,
                closeNavMenu
            }
        },

        methods: {
            'logoClicked': function () {
                if (this.isNavMenuOpened) {
                    this.closeNavMenu()
                    this.closeNavMenuDelay()
                }
                if (this.isGlobalOverlayEnabled) this.disableGlobalOverlay()
                if (this.$parent.$refs.hotspotPanel !== undefined && this.$parent.$refs.hotspotPanel !== null) {
                    this.$parent.$refs.hotspotPanel.closePanel(false)
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    .v-loading-first .towards-zero {
        transform: translateY(-200%);
    }

    .-global-overlay .towards-zero {
        transform: scale(0.9) translateY(-10rem);

        @include gridle_state(large) {
            transform: scale(1) translateY(-10rem);
        }
    }

    .towards-zero {
        transition: transform 0.4s ease-out 0.3s;
        z-index: 199;
        transform-origin: left top;
        transform: scale(0.9) translateY(0);
        position: absolute;
        top: $global-viewport-padding-mobile;
        left: $global-viewport-padding-mobile;
        height: 63px;

        @include gridle_state(large) {
            transform: scale(1) translateY(0);
            top: $global-viewport-padding;
            left: $global-viewport-padding;
        }

        .logo {
            display: block;
            width: 100%;
            //height: 100%;
            //float: left;
        }

        .project-title {
            @include headingsStyle();
            @include alignVertical();
            line-height: 1.2;
            letter-spacing: 5px;
            font-size: 0.9rem;
            width: auto;
            height: 100%;
            float: left;
            color: $white;

            a {
                color: $white;
            }
        }

        .separation {
            width: 1px;
            height: 100%;
            float: left;
            background-color: rgba($white, 0.5);
            margin: 0 .75rem;

            @include gridle_state(medium) {
                margin: 0 1.15rem;
            }
        }

        &.-menu-opened {
            .project-title {
                color: $black;

                a {
                    color: $black;
                }
            }

            .separation {
                background-color: rgba($black, 0.5);
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Towards.vue?58599cd1